enum PhotoSortingTypes {
  DATE = 'date',
}

export default PhotoSortingTypes
